/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { makeStyles } from "../../packages/fluent9";

/**
 * Gets the styles for the FlexItem component.
 * @returns The styles for the FlexItem component.
 */
export const useStyles = makeStyles({
    root: {
        flexShrink: 1,
        height: "auto",
        width: "auto"
    }
});
